module.exports = __webpack_public_path__ + "static/media/m-blog-4.1ec80ebe.jpg";